import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';


@Component({
  selector: 'app-buttons',
  templateUrl: './buttons.component.html',
  styleUrls: ['./buttons.component.scss'],
})
export class ButtonsComponent implements OnInit {
  @Output() clickedNext = new EventEmitter();
  @Output() clickedLast = new EventEmitter();
  @Input() showLastButton: boolean;
  @Input() hideNextButton: boolean;

  constructor() { }

  ngOnInit() {}

  handleClick(direction: string){
    if(direction === 'next'){
      this.clickedNext.emit();
    }
    else{
      this.clickedLast.emit();
    }
  }
}
